import img1 from "./img/1.jpeg";
import img2 from "./img/2.jpeg";
import img3 from "./img/3.jpeg";
import img4 from "./img/4.jpeg";  
import React, { useEffect, useState } from "react";


function Home() {
  const services = [
    {
      title: "Glass UV Printing",
      desc: "Premium UV printing on glass with stylish modern designs.",
    },
    {
      title: "Door UV Printing",
      desc: "Customized digital UV printing for all types of doors.",
    },
    {
      title: "Designer Prints",
      desc: "Modern customized prints with high-quality finishing.",
    },
  ];

  const gallery = [
    img1,
    img2,
    img4
  ];
const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) =>
        prev === gallery.length - 1 ? 0 : prev + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

 
  const styles = {
  page: {
    backgroundColor: "#f5efe6",
    color: "#2d2d2d",
    minHeight: "100vh",
    fontFamily: "Arial, sans-serif",
  },

  header: {
    backgroundColor: "#fffaf3",
    borderBottom: "1px solid #d6c7b2",
    padding: "20px 40px",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },

  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },

  logoSection: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },

  logo: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    objectFit: "cover",
  },

  title: {
    color: "#8b5e3c",
    fontSize: "28px",
    margin: 0,
  },

  subtitle: {
    color: "#7b6a58",
    marginTop: "5px",
    fontSize: "14px",
  },

  menu: {
    display: "flex",
    gap: "25px",
  },

  menuLink: {
    color: "#4b3b2a",
    textDecoration: "none",
    fontSize: "17px",
    fontWeight: "500",
  },

  hero: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "80px 40px",
    gap: "40px",
  },

  heroText: {
    maxWidth: "550px",
  },

  heroHeading: {
    fontSize: "60px",
    lineHeight: "1.2",
    marginBottom: "20px",
    color: "#3e2f1c",
  },

  cyan: {
    color: "#b7791f",
  },

  heroParagraph: {
    color: "#5c4b3b",
    fontSize: "18px",
    lineHeight: "32px",
    marginBottom: "30px",
  },

  button: {
    backgroundColor: "#8b5e3c",
    color: "white",
    padding: "15px 35px",
    borderRadius: "15px",
    textDecoration: "none",
    fontWeight: "bold",
    display: "inline-block",
    boxShadow: "0 5px 15px rgba(139,94,60,0.3)",
  },

  heroImage: {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "30px",
    objectFit: "cover",
  },

  section: {
    padding: "80px 40px",
  },

  darkSection: {
    backgroundColor: "#efe4d4",
    padding: "80px 40px",
  },

  sectionTitle: {
    textAlign: "center",
    color: "#8b5e3c",
    fontSize: "42px",
    marginBottom: "50px",
  },

  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "25px",
  },

  card: {
    backgroundColor: "#fffaf5",
    padding: "30px",
    borderRadius: "20px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
  },

  cardTitle: {
    color: "#8b5e3c",
    fontSize: "24px",
    marginBottom: "15px",
  },

  cardText: {
    color: "#5c4b3b",
    lineHeight: "28px",
  },

  galleryContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "20px",
  },

  galleryImage: {
    width: "100%",
    maxWidth: "900px",
    height: "500px",
    objectFit: "cover",
    borderRadius: "20px",
    transition: "0.5s",
    boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
  },

  dotsContainer: {
    display: "flex",
    gap: "10px",
  },

  dot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: "#cbb79d",
    cursor: "pointer",
  },

  activeDot: {
    backgroundColor: "#8b5e3c",
  },

  whyChooseContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "30px",
  },

  whyCard: {
    background: "#fffaf5",
    padding: "35px",
    borderRadius: "25px",
    width: "300px",
    textAlign: "center",
    border: "1px solid #d6c7b2",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
  },

  whyIcon: {
    fontSize: "50px",
    marginBottom: "20px",
  },

  whyTitle: {
    color: "#8b5e3c",
    fontSize: "24px",
    marginBottom: "15px",
  },

  whyText: {
    color: "#5c4b3b",
    lineHeight: "28px",
    fontSize: "16px",
  },

  contactContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "50px",
  },

  contactText: {
    color: "#5c4b3b",
    fontSize: "18px",
    lineHeight: "35px",
  },

  footer: {
    textAlign: "center",
    padding: "25px",
    borderTop: "1px solid #d6c7b2",
    color: "#7b6a58",
    backgroundColor: "#fffaf3",
  },
};
  return (
    <div style={styles.page}>

      {/* Header */}
      <header style={styles.header}>
        <div style={styles.nav}>

          <div style={styles.logoSection}>
            <img
              src={img3}
              alt="logo"
              style={styles.logo}
            />

            <div>
              <h1 style={styles.title}>
                Sri Venkateswara Doors
              </h1>

              <p style={styles.subtitle}>
                Premium UV Printing Doors
              </p>
            </div>
          </div>

          <div style={styles.menu}>
            <a href="#home" style={styles.menuLink}>Home</a>
            <a href="#services" style={styles.menuLink}>Services</a>
            <a href="#gallery" style={styles.menuLink}>Gallery</a>
            <a href="#contact" style={styles.menuLink}>Contact</a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section id="home" style={styles.hero}>

        <div style={styles.heroText}>
          <h2 style={styles.heroHeading}>
            Modern
            <span style={styles.cyan}> UV Printing </span>
            For Doors 
          </h2>

          <p style={styles.heroParagraph}>
          We provide premium quality UV printing solutions for doors and glass finishing with stylish and modern designs. We can create and print any custom door design based on customer requirements and expectations with high-quality finishing.     </p>

          <a href="#contact" style={styles.button}>
            Contact Us
          </a>
        </div>

        <div>
          <img
            src={img3}
            alt="hero"
            style={styles.heroImage}
          />
        </div>
      </section>

      {/* Services */}
      <section id="services" style={styles.darkSection}>
        <h2 style={styles.sectionTitle}>
          Our Services
        </h2>

        <div style={styles.cards}>
          {services.map((service, index) => (
            <div key={index} style={styles.card}>
              <h3 style={styles.cardTitle}>
                {service.title}
              </h3>

              <p style={styles.cardText}>
                {service.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery */}
      <section id="gallery" style={styles.section}>
        <h2 style={styles.sectionTitle}>
          Our Works
        </h2>

          <div style={styles.galleryContainer}>

        <img
          src={gallery[currentImage]}
          alt="work"
          style={styles.galleryImage}
        />

        {/* Pagination Dots */}
        <div style={styles.dotsContainer}>
          {gallery.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentImage(index)}
              style={{
                ...styles.dot,
                ...(currentImage === index
                  ? styles.activeDot
                  : {}),
              }}
            />
          ))}
        </div>

      </div>

      </section>
<section style={styles.section}>
  <h2 style={styles.sectionTitle}>
    Why Customers Choose Us
  </h2>

  <div style={styles.whyChooseContainer}>

    <div style={styles.whyCard}>
      <div style={styles.whyIcon}>✨</div>

      <h3 style={styles.whyTitle}>
        Premium Finishing
      </h3>

      <p style={styles.whyText}>
        Stylish and high-quality UV printing with premium finishing.
      </p>
    </div>

    <div style={styles.whyCard}>
      <div style={styles.whyIcon}>🎨</div>

      <h3 style={styles.whyTitle}>
        Custom Designs
      </h3>

      <p style={styles.whyText}>
        We provide any customized design based on customer expectations.
      </p>
    </div>

    <div style={styles.whyCard}>
      <div style={styles.whyIcon}>⚡</div>

      <h3 style={styles.whyTitle}>
        Fast Delivery
      </h3>

      <p style={styles.whyText}>
        Quick service with customer satisfaction and timely delivery.
      </p>
    </div>

  </div>
</section>
      {/* Contact */}
      <section id="contact" style={styles.darkSection}>

        <div style={styles.contactContainer}>

          <div>
            <h2 style={styles.sectionTitle}>
              Contact Information
            </h2>

            <div style={styles.contactText}>
              <p>📍76/16/9C,Sri venkateswara Doors, Jojinagar ,Vijayawada -521231, Andhra Pradesh</p>
              <p>
  📞{" "}
  <a
    href="tel:+918639873919"
    style={{
      color: "#5c4033",
      textDecoration: "none",
      fontWeight: "bold",
    }}
  >
    +91 8639873919
  </a>
</p>
              <p>✉️ srivenkateswaradoors@gmail.com</p>
              <p>🕒 9 AM - 9 PM</p>
            </div>

            <a
              href="https://wa.me/918639873919 "
              target="_blank"
              rel="noreferrer"
              style={styles.button}
            >
              Chat on WhatsApp
            </a>
            <p>
              📸 Instagram:{" "}
  <a
    href="https://www.instagram.com/sri_venkateswara_doors"
    target="_blank"
    rel="noreferrer"
    style={{
      color: "green",
      fontWeight: "bold",
      textDecoration: "none",
    }}
  >
    Follow Us on Instagram
  </a>
</p>
          </div>

          <div>
            <h2 style={styles.sectionTitle}>
              Our Location
            </h2>

                    <iframe
              title="location"
  src="https://www.google.com/maps?q=Sri+Venkateswara+doors+Vijayawada&output=embed"
              className="w-full h-80 rounded-2xl border-0 map"
              allowFullScreen=""
              loading="lazy"
               style={{
    width: "100%",
    height: "500px",
    border: 0,
    borderRadius: "20px",
  }}
            ></iframe>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        © 2024 Sri Venkateswara Doors. All Rights Reserved.
         <br />
  Proprietor: Ch Tirupathi Reddy
      </footer>
    </div>
  );
}

export default Home;
